import { Controller } from 'stimulus';

// Reveals the overflow chips inline (sibling chips with .jlv-chip--overflow).
// Toggles .is-expanded on the parent .jlv-chips container — CSS handles the
// rest: overflow chips become visible, this "+N more" button hides itself.
export default class extends Controller {
  reveal(event) {
    event.preventDefault();
    const chips = this.element.closest('.jlv-chips');
    if (chips) chips.classList.add('is-expanded');
  }
}
